import React from 'react';
import { Box } from '@mui/material';

/**
 * Keeps action buttons separated when they wrap. MUI Stack spacing uses child
 * margins, which can collide at responsive breakpoints in action toolbars.
 */
const AdminActionGroup = ({ children, align = 'start', className = '', sx, ...props }) => (
  <Box
    {...props}
    className={`admin-action-group admin-action-group--${align} ${className}`.trim()}
    sx={sx}
  >
    {children}
  </Box>
);

export default AdminActionGroup;
